import { parseXmlElementColor } from '@/common/utils/parseXmlElementColor'

/** Meta token: Swing logs a parse warning and keeps the default fill. */
export const ACTION_OUTLINE_COLOR_TOKEN = 'outlined'

function isWhiteHex(cssColor: string): boolean {
  let hex = cssColor.replace(/^#/, '').toLowerCase()
  if (hex.length === 3) {
    hex = hex.split('').map((ch) => ch + ch).join('')
  }
  if (hex.length === 8) hex = hex.slice(0, 6)
  return hex === 'ffffff'
}

/**
 * Action XML `<color>` / «Цвет фона»: white or `outlined` → SPD outline chrome.
 * Swing: white = light fill; `outlined` = default button (parse miss, no crash).
 */
export function isActionOutlineColor(raw: unknown): boolean {
  const parsed = parseXmlElementColor(raw)
  if (!parsed) return false
  if (parsed.toLowerCase() === ACTION_OUTLINE_COLOR_TOKEN) return true
  return isWhiteHex(parsed)
}
